import React, { useState } from "react";
import { X } from "lucide-react";
import { BASE_URL } from "../../../../utils/constant";
const NewPaymentModal = ({ onClose, delivery, onSuccess }) => {
  const [values, setValues] = useState({
    paid_amount: "",
    remarks: "",
    payment_method: "Cash",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const remainingAmount = Number(delivery?.remaining_payment || 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const amountNum = Number(values.paid_amount);
      if (isNaN(amountNum) || amountNum <= 0) {
        setError("Enter a valid amount greater than 0");
        return;
      }
      if (amountNum > remainingAmount) {
        setError(`Amount cannot exceed remaining \u20B9 ${remainingAmount}`);
        return;
      }
      const accessToken = localStorage.getItem("access");
      const response = await fetch(
        `${BASE_URL}/inventory/create-partpayment/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            delivery: delivery?.id,
            paid_amount: amountNum,
            remarks: values.remarks,
            payment_method: values.payment_method,
          }),
        }
      );

      const data = await response.json();
      if (data.status) {
        onSuccess?.();
        onClose();
      } else {
        setError(data.message || "Failed to create payment");
      }
    } catch (err) {
      setError("Failed to create payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 max-w-md w-full">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold">New Payment</h2>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
          <X size={20} />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Amount
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            max={remainingAmount}
            value={values.paid_amount}
            onChange={(e) => {
              const raw = e.target.value;
              if (raw === "") {
                setValues({ ...values, paid_amount: "" });
                setError("");
                return;
              }
              let num = Number(raw);
              if (isNaN(num)) return;
              if (num < 0) num = 0;
              if (num > remainingAmount) num = remainingAmount;
              setValues({ ...values, paid_amount: num.toString() });
              setError("");
            }}
            className="w-full p-2 border rounded-md"
            required
          />
          <div className="flex justify-between mt-1">
               <span className="text-xs text-gray-500">Remaining: ₹{remainingAmount}</span>
           {Number(values.paid_amount) > remainingAmount && (
                <span className="text-xs text-red-600">Amount exceeds remaining</span>
               )}
          </div>
          {error && (
            <p className="text-sm text-red-600 mt-1">{error}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Payment Method
          </label>
          <div className="flex gap-4">
            {["Cash", "UPI/Bank Transfer", "Cheque"].map((method) => (
              <label key={method} className="flex items-center">
                <input
                  type="radio"
                  name="payment_method"
                  value={method}
                  checked={values.payment_method === method}
                  onChange={(e) =>
                    setValues({ ...values, payment_method: e.target.value })
                  }
                  className="mr-2"
                />
                {method}
              </label>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Remarks
          </label>
          <textarea
            value={values.remarks}
            onChange={(e) => setValues({ ...values, remarks: e.target.value })}
            className="w-full p-2 border rounded-md"
            rows={3}
          />
        </div>

        <button
          type="submit"
          disabled={
            loading ||
            !values.paid_amount ||
            Number(values.paid_amount) <= 0 ||
            Number(values.paid_amount) > remainingAmount
          }
          className="w-full bg-[#3B0069] text-white py-2 rounded-full disabled:opacity-50"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </form>
    </div>
  );
};

const NewCommentModal = ({ onClose, delivery, onSuccess }) => {
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const accessToken = localStorage.getItem("access");
      const response = await fetch(`${BASE_URL}/inventory/create-comment/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          delivery: delivery?.id,
          comment: comment,
        }),
      });

      const data = await response.json();
      if (data.status) {
        onSuccess?.();
        onClose();
      } else {
        setError(data.message || "Failed to create comment");
      }
    } catch (err) {
      setError("Failed to create comment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 max-w-md w-full">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold">Add New Update</h2>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
          <X size={20} />
        </button>
      </div>

      {/* {error && (
        <Alert variant="destructive" className="mb-4">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )} */}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Your Comment
          </label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="w-full p-2 border rounded-md"
            rows={4}
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#3B0069] text-white py-2 rounded-full disabled:opacity-50"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </form>
    </div>
  );
};

// Helper function to delete comment
const deleteComment = async (commentId) => {
  try {
    const accessToken = localStorage.getItem("access");
    const response = await fetch(
      `${BASE_URL}/inventory/delete-comment/${commentId}/`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.ok;
  } catch (err) {
    console.error("Error deleting comment:", err);
    return false;
  }
};

export { NewPaymentModal, NewCommentModal, deleteComment };
